import { render, staticRenderFns } from "./SithMesPrdPdsrRPrpPdrpList.vue?vue&type=template&id=98e8116a&"
import script from "./SithMesPrdPdsrRPrpPdrpList.vue?vue&type=script&lang=js&"
export * from "./SithMesPrdPdsrRPrpPdrpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports